// import axios from "axios";

// // ----------------------------
// // SECURE INSTANCE (MAIN API)
// // ----------------------------
// const axInst = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
//   withCredentials: true, // include HttpOnly cookies
// });

// // No token injection — handled by cookie
// axInst.interceptors.request.use(
//   (config) => config,
//   (error) => Promise.reject(error)
// );

// // ----------------------------
// // SECONDARY API INSTANCE
// // ----------------------------
// const axInst2 = axios.create({
//   baseURL: process.env.REACT_APP_BOT_API_URL,
//   withCredentials: true,
// });

// axInst2.interceptors.request.use(
//   (config) => config,
//   (error) => Promise.reject(error)
// );

// export { axInst, axInst2 };

import axios from "axios";

// ✅ Default instance
const axInst = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axInst.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ✅ Secondary instance
const axInst2 = axios.create({
  baseURL: process.env.REACT_APP_BOT_API_URL, // another base URL
});

axInst2.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { axInst, axInst2 };
